<div class="">
  <div class="mx-auto">
    <div class="flex justify-between items-center mb-10">
      <h2 class="text-4xl font-bold text-gray-800">Department details</h2>
      @if (isAdmin()) {
        <div class="flex gap-3">
          <button
            routerLink="edit"
            class="bg-yellow-400 hover:bg-yellow-500 text-white px-6 py-2 rounded-lg text-lg font-semibold transition"
          >
            Edit
          </button>
          <button
            class="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg text-lg font-semibold transition"
            (click)="onDelete()"
          >
            Delete
          </button>
        </div>
      }
    </div>
    <div class="bg-white rounded-2xl shadow p-10">
      <div class="flex items-center gap-x-4 mb-5">
        <div class="text-xl font-bold text-gray-700">ID:</div>
        <div class="text-xl text-gray-700">{{ department()?.id }}</div>
      </div>
      <div class="flex items-center gap-x-4 mb-5">
        <div class="text-xl font-bold text-gray-700">Name:</div>
        <div class="text-xl text-gray-700">{{ department()?.name }}</div>
      </div>
      <div class="mb-5">
        <div class="text-xl font-bold text-gray-700 mb-2">Description:</div>
        <div class="text-xl text-gray-700">
          {{ department()?.description }}
        </div>
      </div>
    </div>
    <button
      routerLink="/department"
      class="mt-8 mb-10 bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg text-lg font-semibold transition"
    >
      Back to Departments
    </button>
  </div>
</div>

<app-employee-table [departmentId]="departmentId" />
\
<app-delete-confirmation-modal
  [show]="showDeleteDialog"
  (confirmEvent)="onConfirm()"
  (cancelEvent)="onCancel()"
/>
